/**
 * sl-2ulq: GDPR Art. 20 — Data Export
 *
 * Allows users to download their personal data in machine-readable JSON format.
 * Placed in Account Settings above "Delete Account".
 *
 * SOLID: S — Only handles personal data export UI.
 */

import {
  SettingRow,
  SettingWrapper,
} from '@affine/component/setting-components';
import { Button } from '@affine/component/ui/button';
import { useI18n } from '@affine/i18n';
import { DownloadIcon } from '@blocksuite/icons/rc';

import { useDataExport } from './use-data-export';

export const DataExport = () => {
  const t = useI18n();
  const { exportData, isExporting } = useDataExport();

  return (
    <SettingWrapper>
      <SettingRow
        name={t['com.streamlain.settings.data-export']()}
        desc={t['com.streamlain.settings.data-export.description']()}
      >
        <Button
          onClick={exportData}
          loading={isExporting}
          data-testid="data-export-button"
          prefix={<DownloadIcon />}
        >
          {t['com.streamlain.settings.data-export.button']()}
        </Button>
      </SettingRow>
    </SettingWrapper>
  );
};
